/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Uptime status: online/offline from the connected data point, or paused. Null for a device without one
 */
export type DeviceUptimeStatus = (typeof DeviceUptimeStatus)[keyof typeof DeviceUptimeStatus];

export const DeviceUptimeStatus = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  PAUSED: 'paused',
} as const;
